export const FONT_FAMILY_ALT = '"Mortend", sans-serif'
